<template>

  <div style="position: absolute;right: 0;top:0px;height:100%;z-index: 999" :style="{width:width+'px'}">

    <div class="toolbar-wrap" style="">
      <div style="width: 100%;text-align: center;font-size: 18px;height: 60px;line-height: 60px" class="title">操作
      </div>
      <transition name="fade">
        <slot v-if="show"/>
      </transition>
    </div>

  </div>

</template>

<script>
    export default {
        name: "index",
        props: {
            value: {}, width: {
                default() {
                    return 210
                }
            }
        },
        data() {
            return {show: false}
        },
        watch: {
            value(oldValue) {
                this.show = false;
                this.$nextTick(() => {
                    this.show = true;
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
  .toolbar-wrap {
    // box-shadow: 0px 3px 20px rgba(8, 107, 175, 0.33);
    padding-bottom: 5px;
    position: sticky;
    right: 0;
    top: 0;

    .title{
      [data-theme="theme1"] & {
        color:rgba(0,215,213,1);
      }
      [data-theme*="theme2"] & {
        color:rgb(153, 153, 153);
      }
    }

    [data-theme="theme1"] & {
      background:rgba(1,22,39,1);
      box-shadow:0px 3px 20px rgba(0,215,212,0.6);
    }
    [data-theme*="theme2"] & {
      background:#FFF;
      box-shadow: 0 3px 20px rgba(8,107,175,.33);
    }


    // background-color: #fff;

  }

  .fade-enter-active {
    transition: opacity 1.3s;
  }

  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/TableToolBar/index.vue